//api
//import {batchActions} from "redux-batched-actions";
//utils
import * as embedAPIUtil from 'utils/api/embed';

/* ========== ~~~~~~~~~~ EMBEDS STATE > EMBED MANAGEMENT STATE > IMAGE STATUS: ACTION CREATORS ~~~~~~~~~~ ========== */
// ACTION
// utilized by reducers as a call to action to perform some kind of update to application state
// utilized in "_container" components and reducers


const selectImageTab = (provider, images, page_count) => ({
    type: SELECT_IMAGE_TAB,
    provider,
    images,
    page_count
});

const setDataReceived = (data) => ({
    type: SET_DATA_RECEIVED,
    data
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

export const SELECT_IMAGE_TAB = 'SELECT_IMAGE_TAB';

export const SET_DATA_RECEIVED = 'SET_DATA_RECEIVED';

export const ADD_TEMPORARY_IMAGE= 'ADD_TEMPORARY_IMAGE';

export const CLEAR_IMAGE_TAB = 'CLEAR_IMAGE_TAB';

export const IMAGE_ERROR = 'IMAGE_ERROR';

//constants for different image providers

export const UNSPLASH = 'UNSPLASH';

export const SHUTTERSTOCK = 'SHUTTERSTOCK';

export const GIPHY = 'GIPHY';

export const USERIMAGES = 'USERIMAGES';

//THUNKS for getting image API images 
 

//ShutterStock:

export const getShutterStock = (query, page) => dispatch => {
    dispatch(setDataReceived(false))
    embedAPIUtil.queryShutterStock(query,page)
    .then(response => {
        dispatch(selectImageTab(SHUTTERSTOCK, response.data.data, 
            Math.ceil(response.data.total_count/40)));
    })
    .catch((err)=>{if (err!='Cancel') {dispatch(imageErrorOccurred())}});
}


//Unsplash:

export const getUnsplash = (query, page) => dispatch => {
    dispatch(setDataReceived(false))
    embedAPIUtil.queryUnsplash(query,page)
    .then(response => {
        dispatch(selectImageTab(UNSPLASH, response.data.results, response.data.total_pages));
    })
    .catch((err)=>{if (err!='Cancel') {dispatch(imageErrorOccurred())}});
}


//Giphy: 

export const getGiphy = (query, page) => dispatch => {
    dispatch(setDataReceived(false))
    embedAPIUtil.queryGiphy(query,page)
    .then(response => {
        dispatch(selectImageTab(GIPHY, response.data.data, 
            Math.ceil(response.data.pagination.total_count/40)));
    })
    .catch((err)=>{ if (err!='Cancel') {dispatch(imageErrorOccurred())}});
}


export const addTemporaryUserImage = (imageFile) => ({
    type: ADD_TEMPORARY_IMAGE,
    imageFile
});


//User Images:

export const getUserImages = (UUID) => dispatch => {
    dispatch(setDataReceived(false))
    embedAPIUtil.queryUserImages(UUID)
    .then(response => {
        dispatch(selectImageTab(USERIMAGES, response.data, 0));
    })
    .catch((err)=>{if (err!='Cancel') {dispatch(imageErrorOccurred())}});
}


//Clear Image Status:

export const clearImageTab = () => ({
    type: CLEAR_IMAGE_TAB, 
});


//Send Error

export const imageErrorOccurred = () => ({
    type: IMAGE_ERROR
});